import { Modal } from "react-bootstrap";
import { DocumentDismissModalProps } from "../document/Document.types";

export function SplitFileDismissModal({
  show,
  onCancel,
  onDismiss,
}: DocumentDismissModalProps) {
  return (
    <Modal show={show} animation onHide={onCancel}>
      <Modal.Header>
        <h5 className="modal-title" id="Dismiss Modal">
          Dismiss Changes
        </h5>
        <div onClick={onCancel}>
          <span className="font-20 cursor-pointer">&times;</span>
        </div>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to return to the previous page? All changes will
        be lost.
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={onCancel}>
          No
        </button>
        <button type="button" className="btn btn-danger" onClick={onDismiss}>
          Yes
        </button>
      </Modal.Footer>
    </Modal>
  );
}
